import { noop } from '@chillibean/component-library';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { icons as customIcons } from '../__util__/icons';

const Modal = (props) => {
  const { animateModal, modalSize, showModal } = props;

  const animate = animateModal || showModal;
  const modal = animate && (
    <div className={showModal ? 'modal__overlay modal__show' : 'modal__overlay modal__hide'}>
      <div className={`modal__container ${modalSize ? `modal__container--${modalSize}` : ''}`}>{props.children}</div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.getElementById('modal-root') || document.createElement('div'));
};

export function ModalHeader(props) {
  const { children, onCloseClick = noop, withCloseIcon = false } = props;
  return (
    <div className="modal__header">
      {children}
      {withCloseIcon && (
        <div
          tabIndex={0}
          role="button"
          className="modal__header-close-icon"
          onClick={onCloseClick}
          onKeyDown={onCloseClick}
        >
          {customIcons.close()}
        </div>
      )}
    </div>
  );
}

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  withCloseIcon: PropTypes.bool,
  onCloseClick: PropTypes.func,
};

export function ModalBody(props) {
  const { children, customStyles = {}, overflowHidden = false, scroll = undefined } = props;

  return (
    <div
      className={clsx({
        'modal__body': true,
        'modal__body--scroll': scroll,
        'modal__body--overflow-hidden': overflowHidden,
      })}
      style={customStyles}
    >
      {children}
    </div>
  );
}

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  scroll: PropTypes.bool,
  overflowHidden: PropTypes.bool,
  customStyles: PropTypes.shape({}),
};

export function ModalFooter({ children }) {
  return <div className="modal__footer">{children}</div>;
}

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Modal;
